import { useQuery } from "@tanstack/react-query";
import { dashboardProfileOptions } from "@dashboard/api/queryApi";
import { useDashboardProfilesQuery } from "./useDashboardProfilesQuery";

export function useDashboardProfile(
    productInstanceId: number,
    initialProfileName: string,
    selectedProfileId?: number,
) {
    const profilesQuery = useDashboardProfilesQuery(productInstanceId, initialProfileName);
    const profiles = profilesQuery.data ?? [];
    const resolvedProfileId = selectedProfileId ?? profiles[0]?.id ?? null;
    const profileQuery = useQuery(dashboardProfileOptions(productInstanceId, resolvedProfileId));

    return {
        profile: profileQuery.data,
        isPending:
            profilesQuery.isPending || (resolvedProfileId !== null && profileQuery.isPending),
        isError: profilesQuery.isError || profileQuery.isError,
        error: profilesQuery.error ?? profileQuery.error,
    };
}
